(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alanred-happy-day-home"] && !Shopify.designMode) return;
  try {
    
(function () {
  var selector = '[data-ar-happy-day]';

  function initialize(section) {
    if (section.__arHappyCleanup) section.__arHappyCleanup();

    var hoursEl = section.querySelector('[data-ar-hours]');
    var minutesEl = section.querySelector('[data-ar-minutes]');
    var secondsEl = section.querySelector('[data-ar-seconds]');
    var productsArea = section.querySelector('[data-ar-products]');
    var liveAction = section.querySelector('[data-ar-live-action]');
    var upcomingAction = section.querySelector('[data-ar-upcoming-action]');
    var showTeaser = section.dataset.showTeaser === 'true';
    var designMode = section.dataset.designMode === 'true' || Boolean(window.Shopify && window.Shopify.designMode);
    var targetWeekday = 4; // Giovedì: domenica = 0.
    var timerId;
    var disposed = false;
    var listeners = [];

    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      listeners.push(function () { target.removeEventListener(type, handler, options); });
    }

    function validTimeZone(value) {
      var fallback = 'Europe/Rome';
      value = (value || '').trim() || fallback;
      try {
        new Intl.DateTimeFormat('en-CA', { timeZone: value }).format(new Date());
        return value;
      } catch (error) {
        return fallback;
      }
    }

    var timeZone = validTimeZone(section.dataset.timeZone || 'Europe/Rome');
    var zonedFormatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });

    function getZonedParts(date) {
      var values = {};

      zonedFormatter.formatToParts(date).forEach(function (part) {
        if (part.type !== 'literal') values[part.type] = parseInt(part.value, 10);
      });

      return {
        year: values.year,
        month: values.month,
        day: values.day,
        hour: values.hour,
        minute: values.minute,
        second: values.second
      };
    }

    function getTimeZoneOffset(date) {
      var parts = getZonedParts(date);
      var asUtc = Date.UTC(
        parts.year,
        parts.month - 1,
        parts.day,
        parts.hour,
        parts.minute,
        parts.second
      );
      var dateWithoutMilliseconds = Math.floor(date.getTime() / 1000) * 1000;
      return asUtc - dateWithoutMilliseconds;
    }

    function zonedWallTimeToUtc(year, month, day, hour, minute) {
      var wallTimeAsUtc = Date.UTC(year, month - 1, day, hour, minute, 0);
      var firstGuess = new Date(wallTimeAsUtc);
      var firstOffset = getTimeZoneOffset(firstGuess);
      var result = new Date(wallTimeAsUtc - firstOffset);
      var correctedOffset = getTimeZoneOffset(result);

      if (correctedOffset !== firstOffset) {
        result = new Date(wallTimeAsUtc - correctedOffset);
      }

      return result;
    }

    function shiftLocalDate(year, month, day, amount) {
      var shifted = new Date(Date.UTC(year, month - 1, day + amount));
      return {
        year: shifted.getUTCFullYear(),
        month: shifted.getUTCMonth() + 1,
        day: shifted.getUTCDate()
      };
    }

    function getSchedule(now) {
      var localNow = getZonedParts(now);
      var localWeekday = new Date(Date.UTC(localNow.year, localNow.month - 1, localNow.day)).getUTCDay();
      var daysUntilThursday = (targetWeekday - localWeekday + 7) % 7;
      var thursday = shiftLocalDate(localNow.year, localNow.month, localNow.day, daysUntilThursday);
      var opening = zonedWallTimeToUtc(thursday.year, thursday.month, thursday.day, 0, 0);
      // Chiusura esatta alle 23:59:00 dello stesso giovedì, esclusa dalla finestra attiva.
      var closing = zonedWallTimeToUtc(thursday.year, thursday.month, thursday.day, 23, 59);

      if (now.getTime() < opening.getTime()) {
        return { state: 'upcoming', target: opening };
      }
      if (now.getTime() < closing.getTime()) {
        return { state: 'live', target: closing };
      }

      var nextThursday = shiftLocalDate(thursday.year, thursday.month, thursday.day, 7);
      return {
        state: 'upcoming',
        target: zonedWallTimeToUtc(nextThursday.year, nextThursday.month, nextThursday.day, 0, 0)
      };
    }

    function pad(value) {
      return value < 10 ? '0' + value : String(value);
    }

    var productForm = section.querySelector('[data-ar-product-form]');
    var variantSelect = section.querySelector('[data-ar-variant]');
    var addButton = section.querySelector('[data-ar-add-button]');
    var addLabel = section.querySelector('[data-ar-add-label]');
    var purchaseStatus = section.querySelector('[data-ar-purchase-status]');
    var cartLink = section.querySelector('[data-ar-cart-link]');
    var quantityNote = section.querySelector('[data-ar-quantity-note]');
    var pendingAdd = false;
    var uncertainAdd = false;
    var hasAdded = false;

    function selectedVariant() {
      return variantSelect && variantSelect.value ? variantSelect.selectedOptions[0] : null;
    }

    function selectedQuantity(variant) {
      return Math.max(1, parseInt(variant && variant.dataset.minQuantity, 10) || 1);
    }

    function setPurchaseStatus(message, showCartLink) {
      if (purchaseStatus) {
        purchaseStatus.textContent = message;
        purchaseStatus.hidden = !message;
      }
      if (cartLink) cartLink.hidden = !showCartLink;
    }

    function updatePurchaseState() {
      if (!productForm || !addButton) return;
      var variant = selectedVariant();
      var available = variant && variant.dataset.available === 'true';
      var needsPlan = variant && available && variant.dataset.directAdd === 'false';
      var canPurchase = section.dataset.state === 'live' || designMode;
      var quantity = selectedQuantity(variant);
      // Dopo un esito incerto il pulsante mostra il riepilogo qui, senza ripetere l'aggiunta.
      addButton.disabled = pendingAdd || (!uncertainAdd && (!canPurchase || !available || needsPlan));
      if (variantSelect) variantSelect.disabled = pendingAdd;
      productForm.setAttribute('aria-busy', pendingAdd ? 'true' : 'false');
      if (quantityNote) {
        quantityNote.hidden = quantity === 1;
        quantityNote.textContent = 'Quantità minima: ' + quantity + ' pezzi. Il prezzo indicato è per pezzo.';
      }
      if (addLabel) {
        addLabel.textContent = pendingAdd ? 'Aggiunta in corso…' :
          uncertainAdd ? 'Mostra carrello' :
          !canPurchase ? 'Disponibile giovedì' :
          !available ? 'Esaurito' :
          needsPlan ? 'Piano di acquisto richiesto' :
          hasAdded ? 'Aggiungi ancora' :
          quantity > 1 ? 'Aggiungi ' + quantity + ' al carrello' : 'Aggiungi al carrello';
      }
    }

    function moneyText(value) {
      var decoder = document.createElement('textarea');
      decoder.innerHTML = value || '';
      return decoder.value;
    }

    function updateVariant() {
      var variant = selectedVariant();
      if (variant) {
        var original = section.querySelector('[data-ar-original-price]');
        var sale = section.querySelector('[data-ar-sale-price]');
        var saving = section.querySelector('[data-ar-saving]');
        var priceFrom = section.querySelector('[data-ar-price-from]');
        if (original) original.textContent = moneyText(variant.dataset.originalPrice);
        if (sale) sale.textContent = moneyText(variant.dataset.salePrice);
        if (saving) saving.textContent = moneyText(variant.dataset.saving);
        if (priceFrom) priceFrom.textContent = '';
        var image = section.querySelector('[data-ar-featured-image]');
        if (image && variant.dataset.imageSrc) {
          image.src = variant.dataset.imageSrc;
          image.srcset = variant.dataset.imageSrc + ' 1000w';
          image.alt = variant.dataset.imageAlt || '';
        }
        var quantityInput = productForm.querySelector('[name="quantity"]');
        if (quantityInput) quantityInput.value = String(selectedQuantity(variant));
      }
      if (!uncertainAdd) {
        if (variant && variant.dataset.directAdd === 'false') {
          setPurchaseStatus('Questo prodotto richiede un piano di acquisto. La scheda Happy Day supporta l’acquisto singolo.', hasAdded);
        } else {
          setPurchaseStatus(hasAdded ? 'Prodotto aggiunto al carrello.' : '', hasAdded);
        }
      }
      updatePurchaseState();
    }

    var inlineCart = section.querySelector('[data-ar-inline-cart]');
    var cartItems = section.querySelector('[data-ar-cart-items]');
    var cartTotal = section.querySelector('[data-ar-cart-total]');
    var cartOriginal = section.querySelector('[data-ar-cart-original]');
    var cartMessage = section.querySelector('[data-ar-cart-message]');
    var closeCartButton = section.querySelector('[data-ar-close-cart]');
    var cartLoadPromise = null;

    function formatCartMoney(amount, currency) {
      return new Intl.NumberFormat(document.documentElement.lang || 'it', {
        style: 'currency', currency: currency || 'EUR'
      }).format(Number(amount || 0) / 100);
    }

    function renderCart(cart) {
      var currency = cart.currency || 'EUR';
      cartItems.replaceChildren();
      cart.items.forEach(function (item) {
        var row = document.createElement('li');
        row.className = 'ar-hd__cart-item';
        var name = document.createElement('span');
        var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? ' · ' + item.variant_title : '';
        name.textContent = (item.product_title || item.title || 'Prodotto') + variantTitle + ' × ' + item.quantity;
        var prices = document.createElement('span');
        prices.className = 'ar-hd__cart-item-prices';
        var original = Number(item.original_line_price);
        var finalPrice = Number(item.final_line_price == null ? item.line_price : item.final_line_price);
        if (Number.isFinite(original) && original > finalPrice) {
          var oldPrice = document.createElement('s');
          oldPrice.textContent = formatCartMoney(original, currency);
          prices.appendChild(oldPrice);
        }
        var currentPrice = document.createElement('strong');
        currentPrice.textContent = formatCartMoney(finalPrice, currency);
        prices.appendChild(currentPrice);
        row.append(name, prices);
        cartItems.appendChild(row);
      });
      cartTotal.textContent = formatCartMoney(cart.total_price, currency);
      cartOriginal.hidden = !(cart.original_total_price > cart.total_price);
      cartOriginal.textContent = formatCartMoney(cart.original_total_price, currency);
      cartMessage.textContent = cart.items.length ? 'Prezzi e sconti aggiornati dal carrello.' : 'Il carrello è vuoto.';
    }

    function loadCart() {
      if (!inlineCart || !productForm) return Promise.resolve(false);
      inlineCart.hidden = false;
      if (cartLoadPromise) return cartLoadPromise;
      inlineCart.setAttribute('aria-busy', 'true');
      cartMessage.textContent = 'Aggiornamento del carrello…';
      cartLoadPromise = (async function () {
        try {
          var response = await fetch(productForm.dataset.cartReadUrl, {
            credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' }
          });
          if (!response.ok) throw new Error('Carrello non disponibile');
          var cart = await response.json();
          if (!cart || !Array.isArray(cart.items)) throw new Error('Risposta carrello non valida');
          if (disposed) return false;
          renderCart(cart);
          if (uncertainAdd) {
            uncertainAdd = false;
            setPurchaseStatus('Verifica i prodotti nel riepilogo prima di aggiungere di nuovo.', false);
          }
          return true;
        } catch (error) {
          if (!disposed) cartMessage.textContent = 'Non riesco ad aggiornare il riepilogo. Premi “Mostra carrello” per riprovare.';
          return false;
        } finally {
          if (!disposed) {
            inlineCart.setAttribute('aria-busy', 'false');
            updatePurchaseState();
          }
          cartLoadPromise = null;
        }
      })();
      return cartLoadPromise;
    }

    if (cartLink) listen(cartLink, 'click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      loadCart();
    }, true);
    if (closeCartButton) listen(closeCartButton, 'click', function () {
      inlineCart.hidden = true;
      if (cartLink) cartLink.focus();
    });

    function updateCartBadge(result) {
      var currentBadge = document.getElementById('cart-icon-bubble');
      var html = result.sections && result.sections['cart-icon-bubble'];
      if (!currentBadge || typeof html !== 'string') return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var replacement = parsed.getElementById('cart-icon-bubble') || parsed.querySelector('.shopify-section');
      if (replacement) currentBadge.innerHTML = replacement.innerHTML;
    }

    async function addToCart(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (pendingAdd || disposed) return;
      if (uncertainAdd) {
        await loadCart();
        return;
      }
      // Verifica l'orario al clic; nell'editor è consentita la prova del carrello.
      updateCountdown();
      if (section.dataset.state !== 'live' && !designMode) {
        setPurchaseStatus('Happy Day è terminato. Torna giovedì dalle 00:00.', hasAdded);
        return;
      }
      var variant = selectedVariant();
      if (!variant || variant.dataset.available !== 'true') {
        setPurchaseStatus('Scegli una variante disponibile.', hasAdded);
        return;
      }
      if (variant.dataset.directAdd === 'false') {
        setPurchaseStatus('Questo prodotto richiede un piano di acquisto. La scheda Happy Day supporta l’acquisto singolo.', hasAdded);
        return;
      }
      pendingAdd = true;
      updatePurchaseState();
      setPurchaseStatus('', hasAdded);
      var responseReceived = false;
      try {
        var body = { items: [{ id: variant.value, quantity: selectedQuantity(variant) }] };
        if (document.getElementById('cart-icon-bubble')) body.sections = ['cart-icon-bubble'];
        var endpoint = productForm.dataset.cartAddUrl || productForm.action.replace(/\/$/, '') + '.js';
        var response = await fetch(endpoint, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        });
        responseReceived = true;
        var result = await response.json();
        if (disposed) return;
        if (!response.ok || (result && result.status >= 400)) {
          var errorMessage = result && typeof result.description === 'string' ? result.description : 'Non è stato possibile completare l’aggiunta.';
          setPurchaseStatus(errorMessage + ' Controlla il carrello prima di riprovare.', true);
          // Gli errori di disponibilità lasciano scegliere un'altra variante.
          uncertainAdd = response.status >= 500;
          return;
        }
        hasAdded = true;
        setPurchaseStatus('Prodotto aggiunto al carrello.', true);
        // L'aggiornamento del contatore è facoltativo e non può invalidare l'aggiunta.
        try { updateCartBadge(result || {}); } catch (badgeError) {}
        // Una lettura avviata prima del POST potrebbe mostrare il carrello precedente.
        if (cartLoadPromise) await cartLoadPromise;
        if (!disposed) await loadCart();
      } catch (error) {
        if (disposed) return;
        uncertainAdd = true;
        setPurchaseStatus(responseReceived ? 'Controlla il carrello per verificare l’aggiunta.' : 'Connessione interrotta. Controlla il carrello prima di riprovare.', true);
      } finally {
        pendingAdd = false;
        if (!disposed) updatePurchaseState();
      }
    }

    if (variantSelect) listen(variantSelect, 'change', updateVariant);
    if (productForm && addButton) {
      // Il clic è gestito qui: nessun link alla pagina prodotto o invio nativo duplicato.
      listen(addButton, 'click', addToCart, true);
      listen(productForm, 'submit', addToCart, true);
    }

    function updateCountdown() {
      var now = new Date();
      var schedule = getSchedule(now);
      var isLive = schedule.state === 'live';
      var canShowProducts = isLive || designMode;
      var remainingSeconds = Math.max(0, Math.ceil((schedule.target.getTime() - now.getTime()) / 1000));

      section.dataset.state = schedule.state;
      section.hidden = !isLive && !showTeaser && !designMode;
      if (productsArea) productsArea.hidden = !canShowProducts;
      if (liveAction) liveAction.hidden = !canShowProducts;
      if (upcomingAction) upcomingAction.hidden = canShowProducts;

      if (hoursEl) hoursEl.textContent = pad(Math.floor(remainingSeconds / 3600));
      if (minutesEl) minutesEl.textContent = pad(Math.floor(remainingSeconds / 60) % 60);
      if (secondsEl) secondsEl.textContent = pad(remainingSeconds % 60);

      updatePurchaseState();
    }

    function tick() {
      window.clearTimeout(timerId);
      if (disposed) return;
      if (!section.isConnected) {
        section.__arHappyCleanup();
        return;
      }
      updateCountdown();
      // Riallinea ogni aggiornamento al secondo reale, anche dopo la sospensione della pagina.
      if (!document.hidden) timerId = window.setTimeout(tick, 1000 - (Date.now() % 1000));
    }

    section.__arHappyCleanup = function () {
      disposed = true;
      window.clearTimeout(timerId);
      listeners.forEach(function (remove) { remove(); });
      delete section.__arHappyCleanup;
    };

    listen(document, 'visibilitychange', tick);
    listen(window, 'pageshow', tick);
    listen(window, 'focus', tick);
    tick();
    updateVariant();
  }

  function forEachSection(root, callback) {
    if (root.matches && root.matches(selector)) callback(root);
    root.querySelectorAll(selector).forEach(callback);
  }

  function mount(root) {
    forEachSection(root, initialize);
  }

  // Shopify ricarica le sezioni nell'editor senza ricaricare tutta la pagina.
  document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    forEachSection(event.target, function (section) {
      if (section.__arHappyCleanup) section.__arHappyCleanup();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mount(document); }, { once: true });
  } else {
    mount(document);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ar-smart-map"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ar-store-locator-v2')) return;

  // Shared requests, with a second CDN if the first one is unavailable.
  let leafletPromise;
  function loadAsset(kind, url) {
    return new Promise((resolve, reject) => {
      const element = document.createElement(kind === 'css' ? 'link' : 'script');
      let timer;
      const finish = error => {
        window.clearTimeout(timer);
        element.onload = element.onerror = null;
        if (error || kind === 'js') element.remove();
        if (error) reject(error);
        else {
          if (kind === 'css') element.dataset.arLeafletReady = 'true';
          resolve();
        }
      };
      if (kind === 'css') { element.rel = 'stylesheet'; element.href = url; }
      else { element.src = url; element.async = true; }
      element.onload = () => finish();
      element.onerror = () => finish(new Error('Map resource unavailable: ' + kind));
      timer = window.setTimeout(() => finish(new Error('Map resource timeout: ' + kind)), 8000);
      document.head.appendChild(element);
    });
  }
  async function loadFromCDNs(kind) {
    const file = kind === 'css' ? 'leaflet.css' : 'leaflet.js';
    for (const base of ['https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/', 'https://unpkg.com/leaflet@1.9.4/dist/']) {
      try { await loadAsset(kind, base + file); return; } catch (error) { /* Try the other CDN. */ }
    }
    throw new Error('Map resources unavailable');
  }
  function loadLeaflet() {
    if (!leafletPromise) {
      const cssReady = document.querySelector('link[data-ar-leaflet-ready="true"]');
      const jsReady = window.L && typeof window.L.map === 'function';
      leafletPromise = Promise.all([
        cssReady ? Promise.resolve() : loadFromCDNs('css'),
        jsReady ? Promise.resolve() : loadFromCDNs('js')
      ]).then(() => {
        if (!window.L || typeof window.L.map !== 'function') throw new Error('Leaflet unavailable');
        return window.L;
      }).catch(error => { leafletPromise = null; throw error; });
    }
    return leafletPromise;
  }

  const normalize = value => value.trim().toLocaleLowerCase();
  const coordinate = (value, limit) => {
    const raw = value.trim().replace(',', '.');
    if (!/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)$/.test(raw)) return null;
    const result = Number(raw);
    return Number.isFinite(result) && Math.abs(result) <= limit ? result : null;
  };
  const textNode = (tag, className, text) => {
    const element = document.createElement(tag);
    element.className = className;
    element.textContent = text;
    return element;
  };

  class ARStoreLocator extends HTMLElement {
    connectedCallback() {
      this.run = (this.run || 0) + 1;
      const run = this.run;
      // Deferral also covers insertion by the Shopify editor before children parse.
      this.initTimer = window.setTimeout(() => this.init(run), 0);
    }

    disconnectedCallback() {
      this.run += 1;
      window.clearTimeout(this.initTimer);
      window.clearTimeout(this.toastTimer);
      this.events?.abort();
      this.resizeObserver?.disconnect();
      this.map?.remove();
      this.map = null;
      this.markers = new Map();
    }

    async init(run) {
      if (!this.isConnected || run !== this.run) return;
      this.events?.abort();
      this.events = new AbortController();
      const eventOptions = { signal: this.events.signal };
      const retry = this.querySelector('[data-map-retry]');
      if (retry) {
        retry.hidden = true;
        retry.addEventListener('click', () => {
          this.disconnectedCallback();
          this.connectedCallback();
        }, eventOptions);
      }
      this.cards = [...this.querySelectorAll('[data-store]')];
      if (!this.cards.length) return;
      this.groups = new Map();
      this.markers = new Map();
      this.mapInteracted = false;
      this.cards.forEach(card => {
        const title = card.dataset.city.trim() || 'Altre sedi';
        const key = normalize(title);
        if (!this.groups.has(key)) this.groups.set(key, { key, title, label: card.dataset.pinLabel || title, cards: [], points: [] });
        const group = this.groups.get(key);
        group.cards.push(card);
        const lat = coordinate(card.dataset.lat, 90);
        const lng = coordinate(card.dataset.lng, 180);
        if (lat !== null && lng !== null) group.points.push([lat, lng]);
      });
      const cityBar = this.querySelector('[data-cities]');
      cityBar.replaceChildren();
      for (const group of this.groups.values()) {
        if (group.points.length) {
          group.center = [0, 1].map(axis => group.points.reduce((sum, point) => sum + point[axis], 0) / group.points.length);
        }
        group.button = textNode('button', 'ar-smart-map__city', group.title);
        group.button.type = 'button';
        group.button.addEventListener('click', () => this.select(group, true), eventOptions);
        cityBar.appendChild(group.button);
      }
      this.querySelectorAll('[data-copy-store]').forEach(button => { button.hidden = false; });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-copy-store]');
        if (button && this.contains(button)) this.copy(button.dataset.copyStore);
      }, eventOptions);
      this.addEventListener('shopify:block:select', event => {
        const card = this.cards.find(item => item.dataset.blockId === String(event.detail?.blockId));
        if (!card) return;
        this.select(this.groups.get(normalize(card.dataset.city || 'Altre sedi')), true);
      }, eventOptions);
      const initial = this.groups.get(normalize(this.dataset.initialCity || '')) || this.groups.values().next().value;
      this.select(initial, false);
      this.querySelector('[data-panel-head]').hidden = false;
      const mappedGroups = [...this.groups.values()].filter(group => group.center);
      // Keep every city accessible when a map cannot represent all groups.
      if (mappedGroups.length < this.groups.size) cityBar.hidden = false;
      if (!mappedGroups.length) {
        this.querySelector('[data-map-box]').hidden = true;
        this.status('Le sedi sono elencate qui sotto. La mappa sarà disponibile dopo aver aggiunto coordinate valide.');
        return;
      }
      this.querySelector('[data-map-box]').hidden = false;
      this.status('Caricamento mappa…');
      try {
        const L = await loadLeaflet();
        if (!this.isConnected || run !== this.run) return;
        this.L = L;
        this.querySelector('[data-map-box]').hidden = false;
        this.map = L.map(this.querySelector('[data-map]'), {
          scrollWheelZoom: this.dataset.wheel === 'true', zoomControl: true
        });
        const tiles = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19,
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        });
        tiles.on('tileerror', () => this.status('La mappa non è disponibile al momento. Puoi consultare le sedi e aprire gli indirizzi qui sotto.'));
        tiles.addTo(this.map);
        for (const group of mappedGroups) {
          const marker = L.marker(group.center, { icon: this.pinIcon(group, group === this.active), title: group.title, alt: group.title });
          marker.addTo(this.map).on('click', () => this.select(group, true));
          this.markers.set(group.key, marker);
        }
        this.map.fitBounds(mappedGroups.map(group => group.center), { padding: [55, 65], maxZoom: Number(this.dataset.overviewZoom) || 9 });
        this.select(this.active, false);
        this.status('');
        const resizeMap = () => {
          if (!this.map) return;
          this.map.invalidateSize();
          if (!this.mapInteracted) this.map.fitBounds(mappedGroups.map(group => group.center), { padding: [55, 65], maxZoom: Number(this.dataset.overviewZoom) || 9 });
        };
        this.map.on('dragstart', () => { this.mapInteracted = true; });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(resizeMap);
          this.resizeObserver.observe(this.querySelector('[data-map]'));
        }
        window.addEventListener('resize', resizeMap, eventOptions);
        this.addEventListener('shopify:section:select', resizeMap, eventOptions);
        requestAnimationFrame(resizeMap);
      } catch (error) {
        if (!this.isConnected || run !== this.run) return;
        this.map?.remove();
        this.map = null;
        this.querySelector('[data-map-box]').hidden = true;
        if (retry) retry.hidden = false;
        cityBar.hidden = false;
        this.status('La mappa non è disponibile al momento. Puoi consultare le sedi e aprire gli indirizzi qui sotto.');
      }
    }

    count(group) {
      return `${group.cards.length} ${group.cards.length === 1 ? this.dataset.countOne : this.dataset.countMany}`;
    }

    pinIcon(group, active) {
      const wrap = textNode('div', 'ar-smart-pin__wrap', '');
      wrap.appendChild(textNode('div', 'ar-smart-pin__icon', this.dataset.pin || '📍'));
      if (group.cards.length > 1) wrap.appendChild(textNode('div', 'ar-smart-pin__badge', this.count(group)));
      wrap.appendChild(textNode('div', 'ar-smart-pin__label', group.label));
      return this.L.divIcon({
        className: `ar-smart-pin${active ? ' is-active' : ''}`, html: wrap,
        iconSize: [70, 70], iconAnchor: [35, 54], popupAnchor: [0, -46]
      });
    }

    select(group, move) {
      if (!group) return;
      this.active = group;
      this.querySelector('[data-selected-title]').textContent = group.title;
      this.querySelector('[data-selected-label]').textContent = group.cards.length > 1 ? this.dataset.selectedMany : this.dataset.selectedOne;
      this.querySelector('[data-selected-count]').textContent = this.count(group);
      this.cards.forEach(card => { card.hidden = !group.cards.includes(card); });
      this.groups.forEach(item => item.button.setAttribute('aria-pressed', String(item === group)));
      this.markers.forEach((marker, key) => marker.setIcon(this.pinIcon(this.groups.get(key), key === group.key)));
      if (!this.map) return;
      this.map.closePopup();
      if (move && group.center) {
        this.mapInteracted = true;
        const zoom = Number(this.dataset.selectedZoom) || 14;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.map.setView(group.center, zoom);
        else this.map.flyTo(group.center, zoom, { duration: 0.6 });
      }
      const marker = this.markers.get(group.key);
      if (marker) {
        const popup = textNode('div', 'ar-smart-popup', '');
        popup.appendChild(textNode('strong', '', group.title));
        popup.appendChild(textNode('p', '', this.count(group)));
        marker.bindPopup(popup, { autoPan: move }).openPopup();
      }
    }

    status(message) {
      const element = this.querySelector('[data-map-status]');
      element.textContent = message;
      element.hidden = !message;
    }

    toast(message) {
      if (!this.isConnected) return;
      const element = this.querySelector('[data-copy-toast]');
      element.textContent = message;
      element.classList.add('is-visible');
      window.clearTimeout(this.toastTimer);
      this.toastTimer = window.setTimeout(() => element.classList.remove('is-visible'), 2000);
    }

    async copy(text) {
      try {
        if (!navigator.clipboard || !window.isSecureContext) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(text);
        this.toast(this.dataset.copied);
      } catch (error) {
        const previousFocus = document.activeElement;
        const input = document.createElement('textarea');
        input.value = text;
        input.readOnly = true;
        input.style.cssText = 'position:fixed;left:-9999px;top:0';
        document.body.appendChild(input);
        input.select();
        try {
          const copied = document.execCommand('copy');
          this.toast(copied ? this.dataset.copied : 'Copia manualmente l’indirizzo dalla scheda.');
        } catch (copyError) {
          this.toast('Copia manualmente l’indirizzo dalla scheda.');
        } finally {
          input.remove();
          previousFocus?.focus({ preventScroll: true });
        }
      }
    }
  }
  customElements.define('ar-store-locator-v2', ARStoreLocator);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
